import React, { Component } from "react";
import "./partners.scss";
import Footer from "../shared/footer";
import Partners from "../components/partnership/partners";
import MobileNavBar from "../shared/topBar/MobileNavBar/MobileNavBar";
import MainNavBar from "../shared/topBar/MainNavBar/MainNavBar";
import Carousel from "../shared/components/carousel/Carousel";

class PartnersPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            cityHandler: "",
            windowWidth: window.innerWidth,
            carouselContent: [
                {
                    title: "Более 2000 партнёров",
                    container: "Покупайте товары и услуги в рассрочку до 24 месяцев. \nГорода можете посмотреть в разделе «Все города»",
                    text: "",
                    textStyle: {
                        fontFamily: 'Montserrat-Medium',
                        fontSize: '22px!important',
                        lineHeight: '24px',
                        color: '#222222'
                    },
                    img: {
                        src: '',
                        style: {}
                    },
                    style: {
                        backgroundColor: "#D7F4ED",
                        color: '#222222'
                    },
                    button: {
                        link: "salomCardForm",
                        value: "Как купить",
                        type: "",
                        isRouterLink: false,
                        style: {
                            fontFamily: 'Montserrat-Bold',
                            borderRadius: '3px',
                            padding: '23px 50px',
                            fontSize: '18px',
                            whiteSpace: 'nowrap',
                            lineHeight: '22px',
                            color: '#FFFFFF'
                        },
                    },
                    template: "default-template img-center",
                },
                {
                    title: "Одежда и обувь, парфюмерия в рассрочку",
                    container: "Вы можете купить товары или услуги в рассрочку до 24-х месяцев\n у различных партнеров в Душанбе и Худжанде",
                    text: "",
                    textStyle: {
                        fontFamily: 'Montserrat-Medium',
                        fontSize: '22px!important',
                        lineHeight: '24px',
                        color: '#222222',
                                            },
                    img: {
                        src: '',
                        style: {}
                    },
                    style: {
                        backgroundColor: "#D7F4ED",
                        color: '#222222'
                    },
                    button: {
                        link: "salomCardForm",
                        value: "Как купить",
                        type: "",
                        isRouterLink: false,
                        style: {
                            fontFamily: 'Montserrat-Bold',
                            borderRadius: '3px',
                            padding: '23px 50px',
                            fontSize: '18px',
                            whiteSpace: 'nowrap',
                            lineHeight: '22px',
                            color: '#FFFFFF'
                        },
                    },
                    template: "default-template img-center",
                },
            ]
        };

        this.onSelectCity = this.onSelectCity.bind(this);
        this.updateDimensions = this.updateDimensions.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.updateDimensions);
    }

    updateDimensions() {
        this.setState({ windowWidth: window.innerWidth });
    };

    onSelectCity(event) {
        this.setState({
            cityHandler: event
        });
    }

    render() {
        return (
            <div>
                <div className="partners-app">
                    {this.state.windowWidth <= 1200 ? <MobileNavBar /> : <MainNavBar />}
                    <Carousel
                        carouselContent={this.state.carouselContent}
                        arrowsPosition={"arrow-top"}
                    />
                    <Partners
                        windowWidth={this.state.windowWidth}
                        cityHandler={this.state.cityHandler}
                        isLanding={false}
                        className="pt-max"
                    />
                    <Footer />
                </div>
            </div>
        );
    }
}

export default PartnersPage;
